export enum CountryCode {
  RU = "RU",
  US = "US",
  GB = "GB",
  DE = "DE",
  FR = "FR",
  IT = "IT",
  ES = "ES",
  CN = "CN",
  JP = "JP",
  KR = "KR",
  IN = "IN",
  BR = "BR",
  AU = "AU",
  CA = "CA",
  MX = "MX",
  UA = "UA",
  BY = "BY",
  KZ = "KZ",
  UZ = "UZ",
  AZ = "AZ",
  AM = "AM",
  GE = "GE",
  MD = "MD",
  TJ = "TJ",
  TM = "TM",
  KG = "KG",
}

export type DialCode =
  | "+7"
  | "+1"
  | "+44"
  | "+49"
  | "+33"
  | "+39"
  | "+34"
  | "+86"
  | "+81"
  | "+82"
  | "+91"
  | "+55"
  | "+61"
  | "+52"
  | "+380"
  | "+375"
  | "+998"
  | "+994"
  | "+374"
  | "+995"
  | "+373"
  | "+992"
  | "+993"
  | "+996";

export interface CountryPhoneData {
  name: string;
  code: CountryCode;
  dialCode: DialCode;
  mask: string;
}

export const countryPhoneData: CountryPhoneData[] = [
  {
    name: "Россия",
    code: CountryCode.RU,
    dialCode: "+7",
    mask: "+7 (999) 999-99-99",
  },
  {
    name: "США",
    code: CountryCode.US,
    dialCode: "+1",
    mask: "+1 (999) 999-9999",
  },
  {
    name: "Великобритания",
    code: CountryCode.GB,
    dialCode: "+44",
    mask: "+44 99 9999 9999",
  },
  {
    name: "Германия",
    code: CountryCode.DE,
    dialCode: "+49",
    mask: "+49 999 9999999",
  },
  {
    name: "Франция",
    code: CountryCode.FR,
    dialCode: "+33",
    mask: "+33 9 99 99 99 99",
  },
  {
    name: "Италия",
    code: CountryCode.IT,
    dialCode: "+39",
    mask: "+39 999 999 9999",
  },
  {
    name: "Испания",
    code: CountryCode.ES,
    dialCode: "+34",
    mask: "+34 999 99 99 99",
  },
  {
    name: "Китай",
    code: CountryCode.CN,
    dialCode: "+86",
    mask: "+86 999 9999 9999",
  },
  {
    name: "Япония",
    code: CountryCode.JP,
    dialCode: "+81",
    mask: "+81 99 9999 9999",
  },
  {
    name: "Южная Корея",
    code: CountryCode.KR,
    dialCode: "+82",
    mask: "+82 99 999 9999",
  },
  {
    name: "Индия",
    code: CountryCode.IN,
    dialCode: "+91",
    mask: "+91 99999 99999",
  },
  {
    name: "Бразилия",
    code: CountryCode.BR,
    dialCode: "+55",
    mask: "+55 99 99999 9999",
  },
  {
    name: "Австралия",
    code: CountryCode.AU,
    dialCode: "+61",
    mask: "+61 9 9999 9999",
  },
  {
    name: "Канада",
    code: CountryCode.CA,
    dialCode: "+1",
    mask: "+1 (999) 999-9999",
  },
  {
    name: "Мексика",
    code: CountryCode.MX,
    dialCode: "+52",
    mask: "+52 999 999 9999",
  },
  {
    name: "Украина",
    code: CountryCode.UA,
    dialCode: "+380",
    mask: "+380 99 999 99 99",
  },
  {
    name: "Беларусь",
    code: CountryCode.BY,
    dialCode: "+375",
    mask: "+375 99 999-99-99",
  },
  {
    name: "Казахстан",
    code: CountryCode.KZ,
    dialCode: "+7",
    mask: "+7 (999) 999-99-99",
  },
  {
    name: "Узбекистан",
    code: CountryCode.UZ,
    dialCode: "+998",
    mask: "+998 99 999 99 99",
  },
  {
    name: "Азербайджан",
    code: CountryCode.AZ,
    dialCode: "+994",
    mask: "+994 99 999 99 99",
  },
  {
    name: "Армения",
    code: CountryCode.AM,
    dialCode: "+374",
    mask: "+374 99 999999",
  },
  {
    name: "Грузия",
    code: CountryCode.GE,
    dialCode: "+995",
    mask: "+995 999 999999",
  },
  {
    name: "Молдова",
    code: CountryCode.MD,
    dialCode: "+373",
    mask: "+373 9999 9999",
  },
  {
    name: "Таджикистан",
    code: CountryCode.TJ,
    dialCode: "+992",
    mask: "+992 99 999 9999",
  },
  {
    name: "Туркменистан",
    code: CountryCode.TM,
    dialCode: "+993",
    mask: "+993 9 999 9999",
  },
  {
    name: "Киргизия",
    code: CountryCode.KG,
    dialCode: "+996",
    mask: "+996 999 999 999",
  },
];
